// libraries.
import { useFormContext } from 'react-hook-form';

// hooks.
import { useAutocompleteConfidence } from '@domains/documents-review/hooks/useAutocompleteConfidence';

// components.
import { InputField } from '@shared/InputField/InputField';
import { NumericField } from '@shared/NumericField/NumericField';
import { DropdownField } from '@shared/DropdownField/DropdownField';
import { PriceInputField } from '@shared/PriceInputField/PriceInputField';

// constants.
import { DROPDOWN_OPTIONS } from '../../constants';

export const FieldsMX = () => {
  const { watch } = useFormContext();
  const { getConfidenceProps } = useAutocompleteConfidence();

  const hasGarageDoc = watch('hasGarageDoc');
  const isCondominium = Number(watch('propertyType')) === 3;

  return (
    <>
      <InputField
        label="Conjunto*"
        name="complex"
        placeholder="Nombre del conjunto"
        required
        {...getConfidenceProps('complex')}
      />
      <div className="d-flex gap-2">
        <DropdownField
          label="Tipo de Inmueble*"
          name="propertyType"
          options={DROPDOWN_OPTIONS.PROPERTY_TYPE}
          required
          {...getConfidenceProps('propertyType')}
        />
        {isCondominium && (
          <PriceInputField
            label="Valor admin."
            name="adminPrice"
            required
            {...getConfidenceProps('adminPrice')}
          />
        )}
      </div>
      <div className="d-flex gap-2">
        <InputField
          label="Zona mediana*"
          name="medianZone"
          placeholder="Escribir"
          required
          {...getConfidenceProps('medianZone')}
        />
        <InputField
          label="Código postal*"
          name="zipCode"
          placeholder="Escribir"
          required
          {...getConfidenceProps('zipCode')}
        />
      </div>
      <DropdownField
        label="Tipo de documento para determinar el área*"
        name="documentType"
        options={DROPDOWN_OPTIONS.PROPERTY_DOCUMENT_TYPE_OPTIONS}
        required
        {...getConfidenceProps('documentType')}
      />
      <div className="d-flex gap-2">
        <InputField
          label="Área precio comité*"
          maxLength={3}
          name="committeePriceArea"
          pattern={/^\d{1,3}$/}
          placeholder="Área"
          subLabel="m²"
          required
          {...getConfidenceProps('committeePriceArea')}
        />
        <InputField
          label="Área terreno comité*"
          maxLength={3}
          name="committeeLandArea"
          pattern={/^\d{1,3}$/}
          placeholder="Área"
          subLabel="m²"
          required
          {...getConfidenceProps('committeeLandArea')}
        />
      </div>
      <div className="d-flex gap-2">
        <NumericField
          label="Piso*"
          name="floor"
          placeholder="Piso"
          required
          {...getConfidenceProps('floor')}
        />
        <NumericField
          label="Recamaras*"
          name="rooms"
          placeholder="Recamaras"
          required
          {...getConfidenceProps('rooms')}
        />
      </div>
      <div className="d-flex gap-2">
        <NumericField
          label="Baños*"
          name="baths"
          placeholder="Baños"
          required
          {...getConfidenceProps('baths')}
        />
        <NumericField
          label="Medios baños"
          name="halfBaths"
          placeholder="Medios baños"
        />
      </div>
      <div className="d-flex gap-2">
        <NumericField
          label="Elevador*"
          name="elevator"
          placeholder="Elevador"
          required
          {...getConfidenceProps('elevator')}
        />
        <InputField
          label="Antigüedad*"
          maxLength={3}
          name="yearsOld"
          pattern={/^\d{1,3}$/}
          placeholder="Antigüedad"
          subLabel="años"
          required
          {...getConfidenceProps('yearsOld')}
        />
      </div>
      <div className="d-flex gap-2">
        <DropdownField
          label="Documento estacio.*"
          name="hasGarageDoc"
          options={DROPDOWN_OPTIONS.GARAGE}
          required
          {...getConfidenceProps('hasGarageDoc')}
        />
        {hasGarageDoc === 'Si' && (
          <NumericField
            label="Estacionamiento*"
            name="garage"
            placeholder="Estacionamiento"
            required
            {...getConfidenceProps('garage')}
          />
        )}
      </div>
      {hasGarageDoc === 'Si' && (
        <DropdownField
          label="Estacionamiento con doble clave o escritura*"
          name="parkingWithDoubleKeyOrDeed"
          options={DROPDOWN_OPTIONS.YES_NO}
          required
        />
      )}
    </>
  );
};
